import React, { useEffect } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get } from "lodash";
import {
  formatNumberOnDashBoard,
  getLocalstorage,
  isValidArray,
  setLocalstorage
} from "../../helper";
import { connect } from "react-redux";
import { STATUS } from "../../constant";
import NoDataFound from "../../component/NoDataFound";
import { bindActionCreators } from "redux";
import {
  fetchProjectReport,
  getMisListAction,
  clearSelectedStateValue,
  fetchMeetingValue,
  getIssuesReviewed,
  getIssuesResolved,
  getIssuesPending,
  getIssuesTimelineLapsed,
  getmeetingsCount,
  getmeetingsDateAction,
  getMisissueSummaryFileDownload,
  getMisissueSummaryFileCreate,
  onClearDownloadAction
} from "../../actions/mis.action";
import DateList from "../mis/dateList";
import { Link } from "react-router-dom";
import { DownloadExcelReport } from "../reusableComponent";
import { IIG_PATHS, PATHS } from "../../constant";
import { LoaderOverlay } from "../../component/Loader";
class StateSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      loading: true
    };
  }

  componentDidMount() {
    const {
      clearStateYellowChips,
      getmeetingsDateAction,
      getMisListAction,
      getIssuesReviewed,
      selectedState,
      getIssuesResolved,
      getIssuesPending,
      getIssuesTimelineLapsed,
      getmeetingsCount
    } = this.props;
    const meetingType = {
      label: "Cabinet Secretariat",
      name: "Cabinet Secretariat",
      optionName: "Meeting",
      value: "Cabinet Secretariat"
    };

    localStorage.setItem("compilanceFilterList", JSON.stringify([meetingType]));
    localStorage.setItem("meetingType", JSON.stringify(meetingType));

    fetch(getmeetingsDateAction(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});
    fetch(getmeetingsCount(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});

    fetch(getIssuesTimelineLapsed(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});
    fetch(getIssuesPending(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});
    fetch(getIssuesResolved(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});

    fetch(getIssuesReviewed(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});

    fetch(getMisListAction(selectedState, meetingType, 0))
      .then(response => response.json())
      .then(data => {})
      .catch(error => {});
    clearStateYellowChips();
  }

  onStartDownloading = () => {
    const {
      getMisissueSummaryFileCreate,
      selectedState,
      selectMeetingType
    } = this.props;

    fetch(getMisissueSummaryFileCreate(selectedState, selectMeetingType))
      .then(response => {})
      .then(data => {})
      .catch(error => {});
  };

  onClearDownload = () => {
    const { onClearDownloadAction } = this.props;
    onClearDownloadAction();
  };

  render() {
    let {
      selectMeetingType,
      misFlatFileStatus,
      misList,
      misReportList,
      misIssueList,
      selectedState,
      clearSelectedStateValue,
      issuesReviewed,
      issuesResolved,
      issuesPending,
      timeLasped,
      meetingsCount,
      meetingsDate,
      issueUrl,
      isLoading
    } = this.props;

    let formattedDateArray;
    let formattedString;
    console.log("isLoading133", isLoading);

    if (meetingsDate.data !== null && meetingsDate.data !== undefined) {
    }
    if (meetingsDate.data !== null && meetingsDate.data !== undefined) {
      formattedDateArray = meetingsDate.data.meetingDates.map(date => {
        const dateObject = new Date(date * 1000);
        const month = dateObject.getMonth() + 1; // Months are 0-indexed in JavaScript
        const day = dateObject.getDate();
        const year = dateObject.getFullYear();
        const paddedDay = day < 10 ? `0${day}` : day;
        const paddedMonth = month < 10 ? `0${month}` : month;

        return `${paddedDay}-${paddedMonth}-${year}`;
      });

      const dates = formattedDateArray;
      formattedString = dates.join(", ");
    }

    const postMeetingFilterData = async () => {
      const {
        clearStateYellowChips,
        getmeetingsDateAction,
        fetchMeetingValue,
        getMisListAction,
        selectedState,
        getIssuesReviewed,
        getIssuesResolved,
        getIssuesPending,
        getIssuesTimelineLapsed,
        getmeetingsCount
      } = this.props;
      const meeting = {
        label: "Select Meeting Type",
        name: "",
        optionName: "",
        value: ""
      };
      const arrayString = localStorage.getItem("compilanceFilterList");
      const myArray = JSON.parse(arrayString);
      const optionNameToRemove = "Meeting"; // Adjust as needed
      const filteredArray = myArray.filter(
        item => item.optionName !== optionNameToRemove
      );

      const updatedArrayString = JSON.stringify(filteredArray);
      localStorage.setItem("compilanceFilterList", updatedArrayString);
      //localStorage.removeItem("selectedState")
      fetchMeetingValue(meeting);
      localStorage.removeItem("meetingType");
      fetch(getmeetingsDateAction(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getmeetingsCount(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getmeetingsCount(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesTimelineLapsed(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesPending(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesResolved(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesReviewed(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getMisListAction(selectedState, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      clearStateYellowChips();
    };

    const postStateFilterData = async () => {
      const {
        clearStateYellowChips,
        getmeetingsDateAction,
        getMisListAction,
        selectedState,
        getIssuesReviewed,
        getIssuesResolved,
        getIssuesPending,
        getIssuesTimelineLapsed,
        selectMeetingType,
        getmeetingsCount
      } = this.props;
      const arrayString = localStorage.getItem("compilanceFilterList");
      const myArray = JSON.parse(arrayString);
      const optionNameToRemove = "SelectState"; // Adjust as needed
      const filteredArray = myArray.filter(
        item => item.optionName !== optionNameToRemove
      );

      const updatedArrayString = JSON.stringify(filteredArray);
      localStorage.setItem("compilanceFilterList", updatedArrayString);
      localStorage.removeItem("selectedState");
      const states = {
        label: "",
        name: "",
        optionName: "",
        value: ""
      };
      clearSelectedStateValue(selectedState.value);

      fetch(getmeetingsDateAction(selectedState, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getmeetingsCount(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesTimelineLapsed(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesPending(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesResolved(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesReviewed(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getMisListAction(states, selectMeetingType, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      clearStateYellowChips();
    };

    const handleClearAll = () => {
      const {
        clearStateYellowChips,
        getmeetingsDateAction,
        fetchMeetingValue,
        getMisListAction,
        selectedState,
        getIssuesReviewed,
        getIssuesResolved,
        getIssuesPending,
        getIssuesTimelineLapsed,
        selectMeetingType,
        getmeetingsCount
      } = this.props;
      const states = {
        label: "",
        name: "",
        optionName: "",
        value: ""
      };

      localStorage.removeItem("compilanceFilterList");
      localStorage.removeItem("selectedState");
      localStorage.removeItem("meetingType");
      clearSelectedStateValue(states.value);
      const meeting = {
        label: "Select Meeting Type",
        name: "",
        optionName: "",
        value: ""
      };
      fetchMeetingValue(meeting);

      fetch(getmeetingsDateAction(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getmeetingsCount(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesTimelineLapsed(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesPending(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      fetch(getIssuesResolved(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getIssuesReviewed(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});

      fetch(getMisListAction(states, meeting, 0))
        .then(response => response.json())
        .then(data => {})
        .catch(error => {});
      clearStateYellowChips();
    };

    let count = this.props.offset * 10;
    const compilanceFilterList = JSON.parse(
      localStorage.getItem("compilanceFilterList")
    );

    return (
      <React.Fragment>
        {/* <LoaderPage
          loading={
            misFlatFileStatus === STATUS.LOADING || documentsStatusLoader
          }
        /> */}
        <div
          className="row"
          style={{
            paddingLeft: "14px",
            marginTop: "-25px",
            paddingBottom: "10px"
          }}
        >
          {isValidArray(compilanceFilterList)
            ? compilanceFilterList
                .filter(filterData => {
                  return !["", ""].includes(filterData.value);
                })
                .map(filterData => {
                  // const isIIGDraft = status === "IIG_DRAFT";

                  return (
                    <div
                      data-test="applied-filter-on-projects-list"
                      className="applied-state-filter row-state"
                      colspan="2"
                    >
                      {filterData.label}
                      {filterData.optionName === "SelectState" ? (
                        <span
                          data-test="close-button-of-project-list-applied-filter"
                          className="close"
                          onClick={e => {
                            postStateFilterData(filterData);
                          }}
                        >
                          X
                          {/* <button className="read-more-button">X</button> */}
                        </span>
                      ) : (
                        <span
                          data-test="close-button-of-project-list-applied-filter"
                          className="close"
                          onClick={e => {
                            postMeetingFilterData(filterData);
                          }}
                        >
                          X
                          {/* <button className="read-more-button">X</button> */}
                        </span>
                      )}
                    </div>
                  );
                })
            : ""}

          {selectedState.value !== undefined &&
            selectMeetingType.value !== undefined &&
            selectMeetingType.value.length !== 0 &&
            selectedState.value.length !== 0 && (
              <div colspan="2">
                <button className="row-state-clear" onClick={handleClearAll}>
                  Clear All
                </button>
              </div>
            )}
        </div>

        <div className="meeting-summary-div">
          <h6>Meetings Summary</h6>

          <Table className="meetingsummary-table">
            <tbody>
              <tr>
                <th style={{ width: "25%" }}>Number of Meetings Held</th>
                <td style={{ width: "8%" }}>
                  {meetingsCount.data ? meetingsCount.data.agendaCount : "0"}
                </td>
                <th style={{ width: "27%" }}>Meeting Date</th>

                <td>
                  <DateList
                    onSelectStateMonitoring={this.onSelectStateMonitoring}
                    selectedState={selectedState}
                    selectMeetingType={selectMeetingType}
                  />
                </td>
              </tr>
              <tr>
                <th style={{ width: "25%" }}>Number of Issues Reviewed</th>
                <td style={{ width: "8%" }}>
                  {issuesReviewed.data
                    ? issuesReviewed.data.issueReviewedCount
                    : "0"}
                </td>
                <th style={{ width: "27%" }}>Number of Issues Resolved</th>
                <td style={{ width: "40%" }}>
                  {issuesResolved.data
                    ? issuesResolved.data.issueResolvedCount
                    : "0"}
                </td>
              </tr>
              <tr>
                <th style={{ width: "25%" }}>Number of Issues Pending</th>
                <td style={{ width: "8%" }}>
                  {issuesPending.data
                    ? issuesPending.data.issuePendingCount
                    : "0"}
                </td>
                <th style={{ width: "30%" }}>
                  Number of Issues with Timeline Lapsed
                </th>
                <td style={{ width: "40%" }}>
                  {timeLasped.data
                    ? timeLasped.data.issueTimelineLapsedCount
                    : "0"}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        <div className="d-flex align-items-center issue-main-container1">
          <h3 className="m-0 issue-mis-title1">Pending Issues Summary</h3>
          {get(misIssueList, "data") !== null &&
            get(misIssueList, "data") !== undefined && (
              <span>({misIssueList.data.total})</span>
            )}
          <div className="float-right">
            <DownloadExcelReport
              isLoading={isLoading}
              downloadLink={issueUrl}
              onClearDownload={this.onClearDownload}
              onStartDownloading={this.onStartDownloading}
              className="float-right"
              isMis="true"
              iconClass="true"
            />
          </div>
          {/* <LoaderOverlay loading={true} loadingPercent={50} /> */}
        </div>
        <Table
          table="1"
          striped
          size="sm"
          className="state-project-list table table-striped"
        >
          <thead>
            <tr>
              <th colSpan={1} className="state-column-sNo">
                S.No
              </th>
              <th colSpan={3} className="state-column-PName">
                Project Name & ID
              </th>
              <th colSpan={2} className="state-column-issue">
                Issue Title & ID
              </th>
              <th colSpan={1} className="state-column-issueDate">
                Issue Listing Date
              </th>
              <th colSpan={2} className="state-column-rm-sm">
                Recipient State/Ministry
              </th>
              <th colSpan={2} className="state-column-overdue">
                Update Overdue
              </th>
              {/* <th colSpan={1} className="state-column-march24" >March'24 Project</th> */}
              <th colSpan={3} className="state-column-timeline">
                Timeline for Resolution
              </th>
            </tr>
          </thead>
          <tbody>
            {misFlatFileStatus === STATUS.LOADING ? (
              <tr>
                <td colSpan="14">
                  <NoDataFound />
                </td>
              </tr>
            ) : isValidArray(get(misIssueList.data, "listDTO")) ? (
              misIssueList.data.listDTO.map((data, index) => {
                count = count + 1;
                const timestamp = data.listingDate;
                const date = new Date(timestamp * 1000);

                const day = date.getDate();

                const month = date.getMonth() + 1; // Months are 0-indexed in JavaScript

                const year = date.getFullYear();

                const paddedDay = day < 10 ? `0${day}` : day;
                const paddedMonth = month < 10 ? `0${month}` : month;

                const formattedDate = `${paddedDay}-${paddedMonth}-${year}`;
                let timeLineFormatted;
                let meetingFormatted;
                if (data.meetingDate == null && data.timeline == null) {
                  meetingFormatted = "Null";
                  timeLineFormatted = "Null";
                } else if (data.timeline == null) {
                  timeLineFormatted = "Null";
                  const meetinginput = data.meetingDate;
                  const date1 = new Date(meetinginput * 1000);

                  const day1 = date1.getDate();

                  const month1 = date1.getMonth() + 1; // Months are 0-indexed in JavaScript
                  const year1 = date1.getFullYear();
                  const paddedDay = day1 < 10 ? `0${day1}` : day1;

                  const paddedMonth = month1 < 10 ? `0${month1}` : month1;

                  meetingFormatted = `${paddedDay}-${paddedMonth}-${year1}`;
                } else {
                  const meetinginput = data.meetingDate;

                  const date1 = new Date(meetinginput * 1000);

                  const day1 = date1.getDate();

                  const month1 = date1.getMonth() + 1; // Months are 0-indexed in JavaScript

                  const year1 = date1.getFullYear();

                  const paddedDay1 = day1 < 10 ? `0${day1}` : day1;
                  const paddedMonth1 = month1 < 10 ? `0${month1}` : month1;

                  meetingFormatted = `${paddedDay1}-${paddedMonth1}-${year1}`;

                  const timelineInput = data.timeline;
                  const date2 = new Date(timelineInput * 1000);

                  const day2 = date2.getDate();
                  const month2 = date2.getMonth() + 1; // Months are 0-indexed in JavaScript
                  const year2 = date2.getFullYear();
                  const paddedDay2 = day2 < 10 ? `0${day2}` : day2;
                  const paddedMonth2 = month2 < 10 ? `0${month2}` : month2;
                  timeLineFormatted = `${paddedDay2}-${paddedMonth2}-${year2}`;
                }

                let timelineValue;
                if (timeLineFormatted !== "Null") {
                  timelineValue = timeLineFormatted;
                } else {
                  timelineValue = "NA";
                }
                let maxLimit = 50;

                let issuetitle =
                  data.recipientState.length >= 10 ? (
                    <div> {data.recipientState.substring(0, 35)} ... </div>
                  ) : (
                    <div> {data.recipientState} </div>
                  );

                const style = {
                  container: {
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    whiteSpace: "pre-line",
                    maxHeight: "54px"
                  }
                };

                return (
                  <tr>
                    <td className="state-column-sNo-data" colspan="1">
                      {count}
                    </td>
                    <td className="state-column-PName-data" colspan="3">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.projectTitle} #{data.projectId}
                          </Tooltip>
                        }
                      >
                        <Link
                          to={{
                            pathname: PATHS.PROJECT_DETAILS,
                            search: `?projectId=${data.projectId}`,
                            state: {
                              projectId: data.projectId,
                              isEdit: false
                            }
                          }}
                          target="_blank"
                          className="link-compliance"
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              whiteSpace: "pre-line",
                              color: "#727272"
                            }}
                          >
                            {data.projectTitle} #{data.projectId}
                          </div>
                        </Link>
                      </OverlayTrigger>
                    </td>

                    <td className="state-column-issue-data" colspan="2">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.issueTitle} #{data.issueId}
                          </Tooltip>
                        }
                      >
                        <Link
                          to={{
                            pathname: PATHS.ISSUE_DETAIL,
                            search: `?issueId=${data.issueId}&&projectId=${
                              data.projectId
                            }`
                          }}
                          target="_blank"
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              whiteSpace: "pre-line",
                              color: "#727272"
                            }}
                          >
                            {data.issueTitle} #{data.issueId}
                          </div>
                        </Link>
                      </OverlayTrigger>
                    </td>
                    <td className="state-column-issueDate-data" colspan="1">
                      {formattedDate}
                    </td>
                    <td className="state-column-rm-sm-data" colspan="2">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.recipientState}
                          </Tooltip>
                        }
                      >
                        <div
                          style={{
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            whiteSpace: "pre-line"
                          }}
                        >
                          {data.recipientState}
                        </div>
                      </OverlayTrigger>
                    </td>
                    <td className="state-column-overdue-data" colspan="2">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.updateOverDue}
                          </Tooltip>
                        }
                      >
                        {data.updateOverDue.length > 20 ? (
                          <div> {data.updateOverDue.substring(0, 20)} </div>
                        ) : (
                          <div> {data.updateOverDue} </div>
                        )}
                      </OverlayTrigger>
                    </td>
                    {/* <td className="state-column-march24-data" colspan="1">
                      {data.march24 ? "Yes" : "No"}
                    </td> */}
                    <td className="state-column-timeline-data" colspan="3">
                      <div className="row">
                        <span colSpan="2">
                          <b>Meeting Date:</b>&nbsp;
                        </span>
                        <span colSpan="2"> {meetingFormatted}</span>
                      </div>
                      <div className="row">
                        <span colspan="2">
                          <b>Timeline:</b>&nbsp;
                        </span>
                        <span colspan="2"> {timelineValue}</span>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="14">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  //.log("state",state)
  return {
    misFlatFileStatus: state.misReducer.misFlatFileStatus,
    misList: state.misReducer.misList,
    misReportList: state.misReducer.misReportList,
    misIssueList: state.misReducer.misIssueList,
    selectedState: state.misReducer.selectedState,
    selectMeetingType: state.misReducer.selectMeetingType,
    issuesReviewed: state.misReducer.issuesReviewed,
    issuesResolved: state.misReducer.issuesResolved,
    issuesPending: state.misReducer.issuesPending,
    timeLasped: state.misReducer.timeLasped,
    meetingsCount: state.misReducer.meetingsCount,
    meetingsDate: state.misReducer.meetingsDate,
    issueUrl: state.misReducer.issueUrl,
    isLoading: state.misReducer.isLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchProjectReport,
      getMisListAction,

      clearSelectedStateValue,
      fetchMeetingValue,
      getIssuesReviewed,
      getIssuesResolved,
      getIssuesPending,
      getIssuesTimelineLapsed,
      getmeetingsCount,
      getmeetingsDateAction,
      getMisissueSummaryFileDownload,
      getMisissueSummaryFileCreate,
      onClearDownloadAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StateSummary);
